export enum NetworkLabel {
    FlowActions = 'FLOW_ACTIONS',
    UpdateEmail = 'UPDATE_EMAIL'
}
